import type { ComponentProps } from "react"
import { forwardRef } from "react"

type Props = ComponentProps<"svg">

export const FireIcon = forwardRef<SVGSVGElement, Props>((props, ref) => (
	<svg
		width="1em"
		height="1em"
		viewBox="0 0 16 16"
		xmlns="http://www.w3.org/2000/svg"
		ref={ref}
		{...props}
	>
		<path
			fill="currentColor"
			fillRule="evenodd"
			clipRule="evenodd"
			d="M7.19404 1.95116C6.3614 1.33006 5.21202 2.11683 5.49795 3.11217C5.78836 4.12306 5.61779 5.20979 5.03143 6.08457L3.85748 7.83595C3.29836 8.67008 3 9.65015 3 10.6526V10.7576C3 13.5041 5.23858 15.7305 8 15.7305C10.7614 15.7305 13 13.5041 13 10.7576V7.84105C13 6.99781 12.0111 6.53716 11.3598 7.07699L10 8.20403V6.28202C10 4.87329 9.33313 3.54678 8.2 2.70154L7.19404 1.95116ZM8 14.7305C6.75 14.7305 5.5 14.2941 5.5 12.5487C5.5 11.1837 6.51931 9.84093 7.36222 9.14651C7.64036 8.91737 8 9.13388 8 9.49425V11.2395C8 11.5999 8.36968 11.8419 8.69997 11.6978L9.80003 11.2178C10.1303 11.0736 10.5038 11.3159 10.4832 11.6757C10.4109 12.9357 10.0281 14.7305 8 14.7305Z"
		/>
	</svg>
))
